var map = {
	"./en/auth.json": [
		9232,
		851
	],
	"./en/common.json": [
		3535,
		535
	],
	"./en/components.json": [
		4454,
		454
	],
	"./en/footer.json": [
		8337,
		337
	],
	"./en/navigation.json": [
		9240,
		240
	],
	"./en/sections.json": [
		2462,
		462
	],
	"./hy/auth.json": [
		9520,
		520
	],
	"./hy/common.json": [
		7599,
		599
	],
	"./hy/components.json": [
		9766,
		766
	],
	"./hy/footer.json": [
		6785,
		785
	],
	"./hy/navigation.json": [
		3672,
		672
	],
	"./hy/sections.json": [
		1870,
		870
	],
	"./ru/auth.json": [
		634,
		634
	],
	"./ru/common.json": [
		742,
		361
	],
	"./ru/components.json": [
		6232,
		232
	],
	"./ru/footer.json": [
		1091,
		472
	],
	"./ru/navigation.json": [
		8678,
		678
	],
	"./ru/sections.json": [
		1868,
		868
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7162;
module.exports = webpackAsyncContext;